<aside class="aside-portal" *ngFor="let item of itemsAside" style="height: unset; margin-bottom: 30px;">

    <app-aside-banner *ngIf="item.tipoSide=='BANNER'" [itemsAsideBanner]="item" style="width: 100%;">
    </app-aside-banner>

    <app-aside-incorporado *ngIf="item.tipoSide=='INCORPORADO'" [itemsAsideIncorporado]="item" style="width: 100%;">
    </app-aside-incorporado>

</aside>